// The form's values as a query string; given `names`, only the fields with those names.
export default function(form, names) {
  const params = new URLSearchParams(new FormData(form));

  if (!names) return params.toString();

  const picked = [...params].filter(([name]) => names.includes(name));

  return new URLSearchParams(picked).toString();
}
